/*
 * Kyest Home v8 — JS extraído del HTML mockup
 * Bundle: kyest-home theme bundle para shrine-theme-pro (WIP)
 * Source: clientes/kyest/entregables/2026-05-12-web-rebuild/02-home-mockup.html
 * Scripts: hero carousel + mobile drawer + footer accordions + sticky CTA bar visibility
 */

// Sticky CTA mobile — aparece tras scrollear más allá del hero
(function(){
  if (window.matchMedia('(min-width: 768px)').matches) return;
  const bar = document.getElementById('stickyBar');
  const hero = document.querySelector('.hero');
  if (!bar || !hero) return;
  const heroBottom = () => hero.offsetTop + hero.offsetHeight;
  const onScroll = () => {
    if (window.scrollY > heroBottom() - 100) bar.classList.add('visible');
    else bar.classList.remove('visible');
  };
  window.addEventListener('scroll', onScroll, {passive:true});
})();



(function(){
  const track = document.getElementById('heroTrack');
  if(!track) return;
  const slides = Array.from(track.querySelectorAll('.hero-slide'));
  const dots = Array.from(document.querySelectorAll('.hero-dot'));
  const prevBtn = document.querySelector('.hero-arrow.prev');
  const nextBtn = document.querySelector('.hero-arrow.next');
  const pauseBtn = document.querySelector('.hero-pause');
  const carousel = document.querySelector('.hero-carousel');
  if(slides.length < 2) return;

  let current = 0;
  let autoplayTimer = null;
  let userPaused = false;
  const autoplayEnabled = track.dataset.autoplay !== 'false';
  const AUTOPLAY_MS = parseInt(track.dataset.autoplayMs, 10) || 6500;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goTo(index, smooth){
    current = (index + slides.length) % slides.length;
    const slide = slides[current];
    track.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    dots.forEach((d, i) => {
      d.classList.toggle('active', i === current);
      d.setAttribute('aria-selected', i === current ? 'true' : 'false');
    });
  }

  function next(){ goTo(current + 1); }
  function prev(){ goTo(current - 1); }

  function startAutoplay(){
    if(prefersReducedMotion || !autoplayEnabled || userPaused) return;
    stopAutoplay();
    autoplayTimer = setInterval(next, AUTOPLAY_MS);
  }
  function stopAutoplay(){
    if(autoplayTimer){ clearInterval(autoplayTimer); autoplayTimer = null; }
  }

  // Detectar slide actual al hacer scroll manual (swipe)
  let scrollTimeout = null;
  track.addEventListener('scroll', () => {
    if(scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const scrollLeft = track.scrollLeft;
      const slideWidth = slides[0].offsetWidth;
      const newIndex = Math.round(scrollLeft / slideWidth);
      if(newIndex !== current && newIndex >= 0 && newIndex < slides.length){
        current = newIndex;
        dots.forEach((d, i) => {
          d.classList.toggle('active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }
    }, 80);
  }, { passive: true });

  dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); stopAutoplay(); startAutoplay(); }));
  if(prevBtn) prevBtn.addEventListener('click', () => { prev(); stopAutoplay(); startAutoplay(); });
  if(nextBtn) nextBtn.addEventListener('click', () => { next(); stopAutoplay(); startAutoplay(); });

  // Pausar autoplay on hover/focus
  if(carousel){
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
  }

  // Pausar autoplay cuando la pestaña no está visible
  document.addEventListener('visibilitychange', () => {
    if(document.hidden) stopAutoplay();
    else startAutoplay();
  });

  // Soporte teclado para foco en dots/arrows (flecha izq/der)
  document.addEventListener('keydown', (e) => {
    if(!carousel || !carousel.contains(document.activeElement)) return;
    if(e.key === 'ArrowRight'){ e.preventDefault(); next(); stopAutoplay(); startAutoplay(); }
    if(e.key === 'ArrowLeft'){ e.preventDefault(); prev(); stopAutoplay(); startAutoplay(); }
  });

  // === Botón pause/play (WCAG 2.2.2) ===
  if(pauseBtn){
    if(!autoplayEnabled || prefersReducedMotion){
      // Si no hay autoplay no se necesita el botón
      pauseBtn.style.display = 'none';
      if(prefersReducedMotion) userPaused = true;
    } else {
      pauseBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.setAttribute('aria-label', userPaused ? 'Reanudar carrusel' : 'Pausar carrusel');
        if(userPaused) stopAutoplay();
        else startAutoplay();
      });
    }
  }

  // Start
  goTo(0, false);
  startAutoplay();
})();



// === Mobile Drawer · accesibilidad (role=dialog + focus trap + ESC + restore focus) ===
(function(){
  const drawer = document.getElementById('mobileDrawer');
  const hamburger = document.getElementById('menuHamburger');
  const backdrop = document.getElementById('mobileDrawerBackdrop');
  const closeBtn = document.getElementById('mobileDrawerClose');
  if(!drawer || !hamburger || !backdrop) return;

  let lastFocused = null;

  function getFocusable(el){
    return Array.from(el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function(node){
      return node.offsetParent !== null || node === document.activeElement;
    });
  }

  function openDrawer(){
    lastFocused = document.activeElement;
    drawer.classList.add('open');
    backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    hamburger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    // Mover foco al primer elemento focusable dentro del drawer
    const focusable = getFocusable(drawer);
    if(focusable.length > 0) focusable[0].focus();
    else drawer.focus();
  }

  function closeDrawer(){
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    hamburger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    // Devolver foco al botón que abrió el drawer
    if(lastFocused && typeof lastFocused.focus === 'function'){
      lastFocused.focus();
    } else {
      hamburger.focus();
    }
  }

  function handleKeydown(e){
    if(!drawer.classList.contains('open')) return;

    if(e.key === 'Escape'){
      e.preventDefault();
      closeDrawer();
      return;
    }

    if(e.key === 'Tab'){
      const focusable = getFocusable(drawer);
      if(focusable.length === 0){
        e.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if(e.shiftKey && document.activeElement === first){
        e.preventDefault();
        last.focus();
      } else if(!e.shiftKey && document.activeElement === last){
        e.preventDefault();
        first.focus();
      }
    }
  }

  hamburger.addEventListener('click', openDrawer);
  if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', handleKeydown);
})();



(function(){
  var footerDetails = document.querySelectorAll('footer details');
  if(!footerDetails.length) return;
  var mq = window.matchMedia('(min-width: 768px)');
  function sync(){
    footerDetails.forEach(function(d){
      d.open = mq.matches;
    });
  }
  sync();
  if(mq.addEventListener) mq.addEventListener('change', sync);
  else mq.addListener(sync); // Safari < 14
})();


/* ===== HEADER SEARCH DRAWER (2026-05-28 PM-13) ===== */
(function() {
  const btn = document.getElementById('headerSearchBtn');
  const drawer = document.getElementById('headerSearchDrawer');
  const closeBtn = drawer && drawer.querySelector('.header-search-close');
  if (!btn || !drawer) return;
  
  let backdrop = document.querySelector('.header-search-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'header-search-backdrop';
    document.body.appendChild(backdrop);
  }

  /* 2026-07-13 - El drawer se renderiza DENTRO de la seccion del header, que
     vive en un stacking context atrapado a bajo z-index a nivel del body. El
     backdrop (append directo al body, z-index 149) quedaba ENCIMA del popup
     pese a que el drawer es z-index 150 -> lo atenuaba e impedia clicks/lectura
     (input vacio a la vista). Movido el drawer al body para que ambos comparen
     z-index al mismo nivel y el 150 > 149 gane. position:fixed => sin efecto en
     el layout. */
  if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

  function openSearch() {
    drawer.classList.add('open');
    backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    setTimeout(() => {
      const input = drawer.querySelector('input[type="search"]');
      if (input) input.focus();
    }, 280);
  }
  function closeSearch() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
  }
  
  btn.addEventListener('click', () => {
    if (drawer.classList.contains('open')) closeSearch();
    else openSearch();
  });
  closeBtn && closeBtn.addEventListener('click', closeSearch);
  backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeSearch();
  });
})();

/* ===== CART COUNT live update (al agregar productos via Shopify ajax) ===== */
(function() {
  function updateCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(d => {
        const counters = document.querySelectorAll('[data-cart-count]');
        counters.forEach(c => {
          c.textContent = d.item_count;
          c.setAttribute('data-cart-count', d.item_count);
        });
      }).catch(() => {});
  }
  document.addEventListener('cart:updated', updateCount);
  document.addEventListener('product:added', updateCount);
})();

/* ===== ATC INLINE en cards productos (2026-05-28 PM-19) ===== */
(function() {
  function createToast() {
    let toast = document.querySelector('.cart-toast');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `
      <span class="cart-toast-icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      </span>
      <div class="cart-toast-content">
        <strong class="cart-toast-title">Agregado al carro</strong>
        <span class="cart-toast-desc">Producto agregado correctamente</span>
      </div>
      <a href="/cart" class="cart-toast-link">Ver carro</a>
    `;
    document.body.appendChild(toast);
    return toast;
  }
  
  function showToast(productTitle, totalItems) {
    const toast = createToast();
    toast.querySelector('.cart-toast-title').textContent = productTitle ? `${productTitle} agregado` : 'Agregado al carro';
    toast.querySelector('.cart-toast-desc').textContent = `Tu carro tiene ${totalItems} producto${totalItems === 1 ? '' : 's'}`;
    toast.classList.add('show');
    clearTimeout(window.__cartToastTimer);
    window.__cartToastTimer = setTimeout(() => toast.classList.remove('show'), 4000);
  }
  
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }
  
  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    
    const btn = form.querySelector('.btn-atc');
    const productTitle = btn ? btn.dataset.productTitle : '';
    if (btn) btn.setAttribute('data-state', 'loading');
    
    try {
      const formData = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      });
      const data = await res.json();
      
      if (res.ok && !data.errors) {
        // Cart updated · get total
        const cart = await fetch('/cart.js').then(r => r.json());
        updateCartCount(cart.item_count);
        
        if (btn) {
          btn.setAttribute('data-state', 'success');
          setTimeout(() => btn.removeAttribute('data-state'), 2200);
        }
        showToast(productTitle, cart.item_count);
        // Trigger event so otros listeners se actualicen (header cart counter, sticky CTA, etc)
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } else {
        if (btn) btn.removeAttribute('data-state');
        const errMsg = (data && data.description) ? data.description : 'No se pudo agregar al carro. Inténtalo de nuevo.';
        showToast(errMsg, 0);
      }
    } catch (err) {
      console.error('ATC error:', err);
      if (btn) btn.removeAttribute('data-state');
      showToast('Error de conexión. Inténtalo de nuevo.', 0);
    }
  });
})();

/* === TRACKING WhatsApp · evento de conversión global (GA4 + Meta + dataLayer) ===
   Bloqueante del research Google Ads (08-landing-audit): sin click_whatsapp
   la cuenta corre ciega. Listener delegado: cubre TODOS los CTAs wa.me del sitio. */
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]') : null;
  if (!a) return;
  var payload = {
    event: 'click_whatsapp',
    link_url: a.href,
    link_text: (a.textContent || '').trim().substring(0, 60),
    page_path: location.pathname
  };
  try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (err) {}
  // 2026-07-29 fork conversiones: gtag call retirada (el hit lo manda el snippet global kyest-ga4-whatsapp.liquid; este quedaba duplicado). El dataLayer.push GTM-style de arriba queda inerte.
  try { if (typeof fbq === 'function') fbq('trackCustom', 'ClickWhatsApp', { page_path: location.pathname }); } catch (err) {}
}, { capture: true, passive: true });

/* === STICKY ATC MOBILE en PDP (benchmark Belenus · master plan W1) === */
(function () {
  if (!document.body.classList.contains('template-product')) return;
  if (window.innerWidth >= 750) return;
  var realBtn = document.querySelector('.product-form__submit');
  if (!realBtn) return; // PDPs sin ATC (ej. Sculpt) no llevan sticky
  var priceEl = document.querySelector('.price__sale .price-item--sale, .price .price-item--regular');
  var priceTxt = priceEl ? priceEl.textContent.trim() : '';
  var bar = document.createElement('div');
  bar.className = 'kyest-sticky-atc';
  bar.innerHTML = '<div class="kyest-sticky-atc__price">' + priceTxt + '</div>' +
                  '<button type="button" class="kyest-sticky-atc__btn">Agregar al carro</button>';
  document.body.appendChild(bar);
  bar.querySelector('.kyest-sticky-atc__btn').addEventListener('click', function () {
    realBtn.click();
  });
  var trigger = realBtn.getBoundingClientRect().top + window.scrollY + 100;
  var onScroll = function () {
    if (window.scrollY > trigger) bar.classList.add('is-visible');
    else bar.classList.remove('is-visible');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* === CART: imagen de pagos + cuotas dentro del resumen sticky === */
(function () {
  if (!document.body.classList.contains('template-cart')) return;
  var footer = document.querySelector('.cart__footer');
  var pagos = document.querySelector('.kyest-cart-pagos');
  if (!footer) return;
  var ctas = footer.querySelector('.cart__ctas') || footer;
  // línea de cuotas bajo el botón
  var cuotasSrc = document.querySelector('.kyest-cart-conf__cuotas');
  if (cuotasSrc) {
    var nota = document.createElement('p');
    nota.className = 'kyest-resumen-cuotas';
    nota.textContent = cuotasSrc.textContent.replace(/\s+/g, ' ').trim();
    ctas.insertAdjacentElement('afterend', nota);
    cuotasSrc.style.display = 'none';
  }
  if (pagos) {
    footer.appendChild(pagos);
  }
})();
